import { Mapper } from "../../../../base/utils/mapper";
import { ConsultResponseModel } from "../../../../domain/models/consult/consult-response.model";
import { ConsultResponseEntity } from '../entities/consult-response.entity';



export class ConsultImplementationRepositoryMapper extends Mapper<ConsultResponseEntity, ConsultResponseModel> {
    mapFrom(param: ConsultResponseEntity): ConsultResponseModel {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        };
    }
    mapTo(param: ConsultResponseModel): ConsultResponseEntity {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        }
    }
}